var map = {
	"./Dallas Set psd 1.jpg": 9526,
	"./Edamame psd 1.jpg": 7146,
	"./Fried Manti psd 1.jpg": 3598,
	"./Osaka Set.jpg": 7179,
	"./Salmon Tempura.jpg": 1217,
	"./Shrimp Chips psd 1.jpg": 8202,
	"./Shrimp Tempura Roll psd 1.jpg": 3381,
	"./Sushi Vibe Roll.jpg": 7244,
	"./Tom Yum Çorbası.jpg": 2283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9658;